import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { addBranch, AddOrUpdateBranchApiModel, BranchModel } from "@tCentro/Services/CENAdminBranchService";

export interface AddBranchParameter extends HasOnSuccess<BranchModel>, HasOnError<string> {
    model: AddOrUpdateBranchApiModel;
}

type HandlerType = ApiHandler<AddBranchParameter, { apiResult: BranchModel }>;

export const AddBranch: HandlerType = async props => {
    try {
        const result = await addBranch(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to add branch");
        }
    }
};

export const chain = [AddBranch];
const addBranchData = createHandlerChainRunner(chain, "addBranchData");
export default addBranchData;
